import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';

import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { laSapienzaTheme } from './laSapienza';
// import { API_BASE_URL, AutocompleteServiceProxy, BibliographyServiceProxy, CategoryServiceProxy, CategoryTypeServiceProxy, CeramistServiceProxy, ClassCxtServiceProxy, ClassTypesServiceProxy, ComplexDefinitionServiceProxy, ComplexServiceProxy, ContextServiceProxy, EpigraphicElementServiceProxy, ExemplaryServiceProxy, FaciesServiceProxy, InterventionTypeServiceProxy, LocalityServiceProxy, MacroAnalysisServiceProxy, MacrofabricServiceProxy, MonumentServiceProxy, MunicipalityServiceProxy, PetroAnalysisServiceProxy, PhaseServiceProxy, PositionServiceProxy, ProvinceServiceProxy, RegionServiceProxy, ReservedAreaServiceProxy, ServiceProxy, SessionServiceProxy, ShapeServiceProxy, StateServiceProxy, TimeLineServiceProxy, TipoServiceProxy, TokenAuthServiceProxy, TreeTableServiceProxy, TypologicalClarificationServiceProxy, UtilsServiceProxy } from './shared/service-proxies/service-proxies';
// import { abpHttpInterceptorFn } from './shared/abp/abp-http-interceptor-fn';

// import { AppInitializer } from './shared/abp/app-initializer';
import { AppSessionService } from './shared/session/app-session.service';
import { AppAuthService } from './shared/services/app-auth.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { authInterceptor } from './shared/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      }),
      withEnabledBlockingInitialNavigation()
    ),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: laSapienzaTheme,
        options: {
          darkModeSelector: '.app-dark'
        },


      }
    }),
    //TODO: da decommentare: 23-09-2025 da verificare
    // provideAppInitializer(() => {
    //   const initializerFn = ((appInitializer: AppInitializer) =>
    //     appInitializer.init())(inject(AppInitializer));
    //   return initializerFn();
    // }),
    // { provide: API_BASE_URL, useFactory: () => AppConsts.remoteServiceBaseUrl },

    // AccountServiceProxy,
    AppSessionService,
    AppAuthService,
    MessageService,
    ConfirmationService,

  ]
};
